import MainLayout from "@/layouts/tas-admin"
import NotFound from "@/default-page/not-found"

const { default: router } = require("@/router")
const requireModules = require.context(".", true, /_index\.js$/)
const modulesSorter = require("./_order")["default"]
var moduleList = []
var _moduleList = []

requireModules.keys().forEach(folder => {
  if (modulesSorter.indexOf(folder.split("/")[1]) > -1) {
    moduleList[modulesSorter.indexOf(folder.split("/")[1])] = folder
  } else _moduleList.push(folder)
})
const finalModule = [...moduleList, ..._moduleList]



const buildModule = new Promise(async (resolve, reject) => {
  var newModule = []
  let pathList = []
  for (var j = 0; j < finalModule.length; j++) {
    const fileName = finalModule[j]
    if (!fileName) continue;
    const appModules = requireModules(fileName).default
    if (appModules.config.name === "Quality") continue

    const moduleName = fileName
      .split("/")[1]
      .split("-")
      .map(kebab => kebab.toLowerCase())
      .join("-")

    var newRoutes = []
    for (var i = 0; i < appModules.routes.length; i++) {
      var r = appModules.routes[i]

      var permission = null
      if (r.type == 'parent') {
        for (const [keyChild, child] of Object.entries(r.child)) {
          child.parentName = r.name
          child.parentIcon = r.icon
          child.path = "/" + moduleName + "/" + r.name + child.path
          child.meta = {
            icon: child.icon,
            separator: child.separator || null,
            title: child.name
              .split("-")
              .map(
                kebab =>
                  kebab
                    .toLowerCase()
                    .charAt(0)
                    .toUpperCase() + kebab.slice(1)
              )
              .join(" "),
          }
          if (child.component) {
            const data = await child.component()
            if (data.default.data instanceof Function) {
              var config = data.default.data().config
              child.meta.permission = config ? config.permission : null
            } else {
              continue;
            }
          } else {
            child.component = () => import("@/default-page/maintenance.vue")
          }
        }

      } else if (r.component) {
        const data = await r.component()
        if (data.default.data instanceof Function) {
          var config = data.default.data().config
          permission = config ? config.permission : null
        } else {
          continue;
        }
      } else {
        r.component = () => import("@/default-page/maintenance.vue")
      }
      r = {
        ...r,
        meta: {
          title: r.name
            .split("-")
            .map(
              kebab =>
                kebab
                  .toLowerCase()
                  .charAt(0)
                  .toUpperCase() + kebab.slice(1)
            )
            .join(" "),
          icon: r.icon,
          permission: permission,
          separator: r.separator || null,
        },
        path: "/" + moduleName + r.path
      }

      

      if (i === 0) {
        let checkIfExist = router.resolve({ name: "main-module" })
        if (checkIfExist.resolved.matched.length === 0) {
          try {
            router.addRoute({
              path: "/",
              name: "main-module",
              component: MainLayout,
              redirect: { name: r.redirectName || r.name }
            })
          } catch (error) {
            console.log(error)
          }
        }
      }

      // add routes to router
      function addRouteToRouter(rFinale) {
        if (appModules.config.layout) router.addRoute("main-module", rFinale)
        else router.addRoute(rFinale)
        
        newRoutes.push(rFinale)
        
        pathList.push(rFinale.path)
      }

      if (r.type == 'parent') {
        for (const [keyChild, child] of Object.entries(r.child)) { 
          addRouteToRouter(child)
        }
      } else { 
        addRouteToRouter(r)
      }
    }




    var vueX = appModules.config

    vueX.routes = newRoutes
    newModule.push(vueX)
  }

  router.addRoute({
    path: "*", component: NotFound,
    beforeEnter (to, from, next) {
      const fullPath = from.path

      if (!pathList.includes(fullPath)) {
        next()
      }
    }
  })

  newModule.sort((a, b) => {
    return a.order - b.order
  })
  resolve(newModule)
})

export default buildModule



// WEBPACK FOOTER //
// ./src/modules/_registration.js